var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraspIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7964 0.243147C21.1237 0.105011 20.1259 1.51706 15.6511 4.16211C8.22864 8.55688 6.39594 7.36994 3.60108 10.8131C-2.15155 17.6176 0.612762 24.3555 8.39154 27.5992C17.9572 31.6307 28.6021 26.402 31.6922 15.7502C32.3082 13.4121 33.6573 8.30108 30.6741 4.21328C29.8798 3.0928 28.854 2.15798 27.667 1.47276C26.4799 0.787548 25.1596 0.368111 23.7964 0.243147Z",
    fill: "#237FC0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraspIcon);
export default __webpack_public_path__ + "static/media/grasp_icon.c8030afaea9af5f43957fb55b75fff75.svg";
export { ForwardRef as ReactComponent };